import React from 'react'
import { RouteComponentProps } from '@reach/router'

const context = process.env.PUBLIC_URL

export default function NotFound(props: RouteComponentProps) {
    return (
        <div className="flex content-center min-h-screen p-20 shadow-2xl justify-center items-center">
            <img alt="Imagen de error" className="opacity-75" style={{height: '500px'}} src={`${context}/img/error.png`}></img>
        </div>
    )
}
